import {useLocation, useNavigate} from 'react-router';
import {useCallback, useEffect} from 'react';
import menuData from '../types/menuData.json';
import MenuItem from './MenuItem.tsx';
import type {TMenuItem} from '../types';

const MenuList = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const getCurrentMenu = () => {
        const path = location.pathname.slice(1);
        return path || 'streaming';
    };
    const activeMenu = getCurrentMenu();

    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/streaming');
        }
    }, [location.pathname, navigate]);

    const checkActive = useCallback(
        (itemName: string): boolean =>
            location.pathname.includes('/busArrived') || location.pathname.includes('/foodInfo')
                ? itemName === 'amenities'
                : activeMenu === itemName,
        [activeMenu, location.pathname]
    );

    return (
        <>
            {menuData.map((item) => (
                <MenuItem key={item.name} item={item as TMenuItem} isActive={checkActive(item.name)} />
            ))}
        </>
    );
};

export default MenuList;
